import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { ShareholderInfoResponse, ShareholderInfo } from '../models/shareholderInfo';

export const onGetShareholdersInfoList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<ShareholderInfoResponse>>('dashboard/actions/shareholder-information', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetShareholderInfoById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<ShareholderInfo>>(`dashboard/actions/shareholder-information/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onRequestShareholderInfo = async (national_id: string) => {
	try {
		const response = await axios.post<JsonResponse<ShareholderInfo>>(
			'dashboard/actions/shareholder-information',
			{},
			{
				params: { national_id },
			},
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
